import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezonePlugin from 'dayjs/plugin/timezone';
import utcPlugin from 'dayjs/plugin/utc';

export const setupDayjsExtensions = () => {
  dayjs.locale('en');
  dayjs.extend(utcPlugin);
  dayjs.extend(timezonePlugin);
  dayjs.extend(isBetween);
  dayjs.extend(relativeTime);
  dayjs.extend(duration);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter);
};
